module.exports = __webpack_public_path__ + "img/paypal-checkout.99b53e38.png";